// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services --------------------
import { cadastrarEtiqueta } from "../../../services/cadastrarEtiquetaService";

export const useCadastrarEtiqueta = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [success, setSuccess] = useState<boolean | null>(null);

  const resetError = () => setError(null);

  const cadastrar = async (data: any) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const cadastrarCamp = await cadastrarEtiqueta(data);

      if (cadastrarCamp) {
        setSuccess(true);
      } else {
        setError(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    cadastrar,
    isLoading,
    isSuccess,
    error,
    success,
    resetError,
  };
};
